import React, { FC } from 'react';
import { IconProps } from '.';

export const InformationIcon: FC<IconProps> = ({ size = 24, ...props }) => {
    const sizing = { width: size, height: size };

    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...sizing} {...props}>
            <path
                fill="currentColor"
                d="M11.82 18.06h.36c.37 0 .67-.3.67-.67v-7.15c0-.37-.3-.66-.67-.66h-.36c-.37 0-.67.3-.67.66v7.15c0 .37.3.67.67.67Z"
            />
            <circle cx="12" cy="7.21" r="1.03" fill="currentColor" transform="rotate(-180 12 7.21)" />
            <path
                fill="url(#4aac633c)"
                fillRule="evenodd"
                d="M21.1 12A9.1 9.1 0 0 0 12 2.9V2a10 10 0 0 1 10 10h-.9Z"
                clipRule="evenodd"
            />
            <path
                fill="currentColor"
                d="M21.1 12a9.1 9.1 0 1 1-9.55-9.08.47.47 0 0 0 .45-.46c0-.26-.2-.46-.45-.45a10 10 0 1 0 10.45 10h-.9Z"
            />
            <defs>
                <linearGradient id="4aac633c" x1="21.67" x2="12.33" y1="12" y2="2.39" gradientUnits="userSpaceOnUse">
                    <stop stopColor="currentColor" />
                    <stop offset="1" stopColor="currentColor" stopOpacity="0" />
                </linearGradient>
            </defs>
        </svg>
    );
};
